export const loginCredentials = {
  email: "",
  password: "",
  vatNumber: "",
};
